<template>
  <div>
    <div class="service-summary">
      <PackageSummary
        class="package-summary"
        :joining-tenant="joiningTenant"
        :single-column="true"
      >
        <template v-slot:summary-header>
          <h2 class="content-panel__title">We'll set up these services</h2>
        </template>
        <template v-slot:summary-footer>
          <slot></slot>
          <div class="summary-price-info">
            <span>For A Total Of</span>
            <section class="price-display">
              <strong class="weekly-price-old" v-if="nonDiscountedPppw">
                £{{ nonDiscountedPppw }}
              </strong>
              <strong class="weekly-price" data-testid="summary-price-pppw"
                >£{{ ppppw }}</strong
              >
            </section>
            <span class="pppw">per person per week</span>
            <span class="collected-monthly"
              >collected monthly by direct debit</span
            >
            <monthly-price-info class="collected-monthly" />
          </div>
        </template>
      </PackageSummary>

      <div class="vl" />

      <PackageSchedule
        class="package-schedule"
        :tenancy-start-date="tenancyStartDate"
        :tenancy-end-date="tenancyEndDate"
        :first-payment-date="firstPaymentDate"
        :broadband-installation-date="broadbandDate"
      />
    </div>

    <div class="price-info">
      <span class="total-of">For A Total Of</span>
      <section class="price-display">
        <strong class="weekly-price-old" v-if="nonDiscountedPppw">
          £{{ nonDiscountedPppw }}
        </strong>
        <strong class="weekly-price">£{{ ppppw }}</strong>
      </section>
      <span class="pppw">per person per week</span>
      <span class="collected-monthly"> collected monthly by direct debit</span>
      <monthly-price-info />
    </div>
  </div>
</template>

<script>
import PackageSummary from "@/components/PackageSummary";
import PackageSchedule from "@/components/PackageSchedule";
import MonthlyPriceInfo from "@/components/MonthlyPriceInfo.vue";

export default {
  name: "ServiceSummary",
  components: {
    MonthlyPriceInfo,
    PackageSchedule,
    PackageSummary,
  },
  data() {
    return {
      toggleWeeklyPrice: true,
    };
  },
  props: {
    joiningTenant: {
      type: Boolean,
      required: false,
      default: false,
    },
    discountDescription: {
      type: String,
      required: false,
    },
    nonDiscountedPppw: {
      type: String,
      required: false,
    },
    nonDiscountedPpppm: {
      type: [Number, String],
      required: false,
    },
    ppppw: {
      type: String,
      required: true,
    },
    ppppm: {
      type: [Number, String],
      required: true,
    },
    tenancyStartDate: {
      type: String,
      required: true,
    },
    tenancyEndDate: {
      type: String,
      required: true,
    },
    firstPaymentDate: {
      type: String,
      required: true,
    },
    broadbandDate: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.service-summary {
  display: grid;
  grid-template-columns: 1fr 1px 1fr;
  grid-template-rows: auto;
  grid-auto-flow: row;
  grid-row-gap: 1rem;
  grid-column-gap: $spacing-medium;

  background: $white;
  border-radius: $border-radius-large;
  padding: 20px;
  margin-bottom: $spacing-large;

  justify-content: space-between;

  @include media("<medium") {
    padding: 0;
    background-color: transparent;

    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    grid-column-gap: 0;
    grid-row-gap: 0;
  }

  .package-summary {
    background: $white;

    .summary-price-info {
      text-align: center;
      margin: $spacing-small 0;

      @include media(">=medium") {
        display: none;
      }

      section.price-display {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.3em;
      }

      span,
      strong {
        display: block;
      }
    }

    @include media("<medium") {
      padding: 0 $spacing-small;
      border-radius: $border-radius-large;
      box-shadow: $brand-box-shadow;

      .content-panel__title {
        margin: $spacing-small 0;
        font-size: $title-font-size-mob;
        text-align: center;
      }
    }
  }

  .package-schedule {
    background: $white;

    @include media("<medium") {
      order: 3;

      box-shadow: $brand-box-shadow;
      border-radius: $border-radius-large;
      margin: $spacing-medium 0 0 0;
      justify-content: space-evenly;
      padding: $spacing-small 0 $spacing-small $spacing-small;
    }
  }

  .vl {
    position: relative;
    height: 95%;
    top: 2.5%;
    width: 0;
    border: 1px solid #224b8126;
    border-radius: 1px;

    @include media("<medium") {
      display: none;
    }
  }
}

.price-info {
  font-size: 16px;
  text-align: center;
  margin: $spacing-medium 0;
  color: $brand-dark-blue;

  @include media("<medium") {
    display: none;
  }

  span,
  strong {
    display: block;
  }
}

.total-of {
  font-size: 28px;
  font-weight: $font-light;
}

.weekly-price {
  font-size: 45px;
  font-weight: $font-bold;
  color: $brand-blue;
}

.weekly-price-old {
  font-size: 35px;
  font-weight: $font-bold;
  color: #959595;
  text-decoration: line-through;
}

.monthly,
.collected-monthly,
.pppw {
  font-size: 16px;
}
</style>
